<template>
    <div class="page-modal">
        <widgetModal title="Update Account Owner" :subtitle="content && content.length > 0 ?
            `Assign an account owner to ${content.length} selected account${content.length > 1 ? 's' : ''}` :
            'Assign an account owner to the selected accounts'" btnlefttext="Save Changes" btncentertext="Cancel"
            :leftloading="updating_loading" :centerloading="false" :footerhidden="false" :hiderightbtn="true"
            footer_padding="10px 18px 30px 30px" header_padding="30px 0px 0px 31px" body_padding="0px 30px"
            width="400px" @onLeftClick="onConfirm()" @onCenterClick="onCancel">
            <div class="widget-modal-body-noscoll">
                <div class="row">
                    <widgetInputWrapper title="Account Owner">
                        <searchSelectInput url="/company/search/manager" :miltiple="true" type="site" v-model="assigned"
                            placeholder="Search account owner">
                            <template v-slot:result="{ result }">
                                <span class="search-contact-item">
                                    <img width="20" v-if="result.profile_picture"
                                        :src="$fullUrl('images/profiles/' + result.profile_picture)" />
                                    <img v-else width="20" src="@/assets/avatar.png" />
                                    {{ result.first_name | validate }}
                                    {{ result.last_name | validate }}
                                </span>
                            </template>
                            <template v-slot:selected="{ selected }">
                                <span class="selected-search-contact-item">
                                    <img width="20" v-if="selected.profile_picture"
                                        :src="$fullUrl('images/profiles/' + selected.profile_picture)" />
                                    <img v-else width="20" src="@/assets/avatar.png" />
                                    {{ selected.first_name | validate }}
                                </span>
                            </template>
                        </searchSelectInput>
                    </widgetInputWrapper>
                </div>
            </div>
        </widgetModal>
    </div>
</template>

<script>
import { eventBus } from "@/main";

export default {
    name: "update-account-owner-modal",
    props: {
        content: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            assigned: {
                added: [],
                removed: [],
            },
            updating_loading: false
        };
    },
    mounted() {
        // Nothing to initialize
    },
    methods: {
        onConfirm() {
            let vm = this;

            if (vm.assigned.added.length === 0) {
                vm.$notify({
                    group: "status",
                    title: "Message",
                    text: "Please select an account owner",
                    type: "warn",
                    duration: 3000,
                });
                return;
            }

            vm.updating_loading = true;

            // Get IDs of selected accounts
            const accountIds = vm.content.map(account => account.id);

            // Prepare account owner data
            const accountOwner = JSON.stringify(vm.assigned.added);

            vm.$store
                .dispatch("ACCOUNT_UPDATE_OWNER", {
                    ids: accountIds,
                    account_owner: accountOwner
                })
                .then((response) => {
                    vm.updating_loading = false;
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Account owner updated successfully",
                        type: "success",
                        duration: 3000,
                    });
                    vm.$emit("success");
                })
                .catch((error) => {
                    vm.updating_loading = false;
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Something went wrong",
                        type: "warn",
                        duration: 3000,
                    });
                    console.error({ error });
                });
        },
        onCancel() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
.page-modal {
    // Styles if needed
}
</style>